import PhotoWithBackdrop from './PhotoWithBackdrop';
import { motion } from 'framer-motion';

export default function TextBoxImage() {
  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '1.5rem',
    alignItems: 'center',
    minHeight: '400px'
  };

  const imageContainerStyle = {
    width: '100%',
    height: '400px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem' // Add padding to account for backdrop offset
  };

  return (
    <section className="bg-white py-8 md:py-12 font-nunito px-4 md:px-0 relative overflow-hidden">
      {/* Floating bubbles background */}
      <motion.div
        className="absolute top-1/6 left-1/6 w-3 h-3 bg-red-200 rounded-full opacity-40"
        animate={{ 
          y: [0, -30, 0],
          x: [0, 15, 0],
          scale: [1, 1.3, 1]
        }}
        transition={{ 
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <motion.div
        className="absolute top-1/4 right-1/4 w-2 h-2 bg-orange-200 rounded-full opacity-50"
        animate={{ 
          y: [0, -25, 0],
          x: [0, -10, 0],
          scale: [1, 1.4, 1]
        }}
        transition={{ 
          duration: 3.5,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.5
        }}
      />
      <motion.div
        className="absolute top-1/3 left-1/3 w-4 h-4 bg-yellow-200 rounded-full opacity-30"
        animate={{ 
          y: [0, -35, 0],
          x: [0, 8, 0],
          scale: [1, 1.2, 1]
        }}
        transition={{ 
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1
        }}
      />
      <motion.div
        className="absolute top-1/5 right-1/5 w-1.5 h-1.5 bg-pink-200 rounded-full opacity-60"
        animate={{ 
          y: [0, -20, 0],
          x: [0, -5, 0],
          scale: [1, 1.5, 1]
        }}
        transition={{ 
          duration: 2.5,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1.5
        }}
      />
      <motion.div
        className="absolute top-1/2 left-1/5 w-2.5 h-2.5 bg-green-200 rounded-full opacity-35"
        animate={{ 
          y: [0, -28, 0],
          x: [0, 12, 0],
          scale: [1, 1.3, 1]
        }}
        transition={{ 
          duration: 4.5,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.8
        }}
      />
      <motion.div
        className="absolute top-3/5 right-1/3 w-3.5 h-3.5 bg-purple-200 rounded-full opacity-25"
        animate={{ 
          y: [0, -32, 0],
          x: [0, -8, 0],
          scale: [1, 1.1, 1]
        }}
        transition={{ 
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 2
        }}
      />
      <motion.div
        className="absolute top-2/3 left-2/5 w-1 h-1 bg-cyan-200 rounded-full opacity-70"
        animate={{ 
          y: [0, -18, 0],
          x: [0, 6, 0],
          scale: [1, 1.6, 1]
        }}
        transition={{ 
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.3
        }}
      />
      <motion.div
        className="absolute top-3/4 right-1/4 w-2 h-2 bg-indigo-200 rounded-full opacity-45"
        animate={{ 
          y: [0, -26, 0],
          x: [0, -12, 0],
          scale: [1, 1.4, 1]
        }}
        transition={{ 
          duration: 4.2,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1.2
        }}
      />
      <motion.div
        className="absolute top-4/5 left-1/3 w-3 h-3 bg-teal-200 rounded-full opacity-30"
        animate={{ 
          y: [0, -30, 0],
          x: [0, 10, 0],
          scale: [1, 1.2, 1]
        }}
        transition={{ 
          duration: 5.5,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.7
        }}
      />
      <motion.div
        className="absolute top-5/6 right-1/5 w-1.5 h-1.5 bg-rose-200 rounded-full opacity-55"
        animate={{ 
          y: [0, -22, 0],
          x: [0, -7, 0],
          scale: [1, 1.5, 1]
        }}
        transition={{ 
          duration: 3.8,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1.8
        }}
      />
      <div className="max-w-7xl mx-auto">
        {/* Mobile layout */}
        <div className="md:hidden">
          <div className="bg-red-200 p-4 rounded-lg text-dblue font-medium shadow mb-4">
            <h3 className="font-bold text-lg mb-2">Offering Space to a New Family</h3>
            <p className="text-sm">
              When there is a childcare space available, our Administrator will try to contact your family by way of phone and email.
              We require that you respond to the offer within 3 business days.
            </p>
            <p className="mt-2 text-sm">
              If after 3 business days without success of a response, we will have no other alternative but to offer the childcare space available to the next family on the list.
            </p>
          </div>
          <div className="flex justify-center">
            <PhotoWithBackdrop src="/images/kidsattable.jpg" alt="Childcare Offering" size="sm" />
          </div>
        </div>

        {/* Desktop layout */}
        <div className="hidden md:block">
          <div style={gridStyle}>
            <div className="bg-red-200 p-6 rounded-lg text-dblue font-medium shadow flex flex-col justify-center">
              <h3 className="font-bold text-lg mb-2">Offering Space to a New Family</h3>
              <p>
                When there is a childcare space available, our Administrator will try to contact your family by way of phone and email.
                We require that you respond to the offer within 3 business days.
              </p>
              <p className="mt-2">
                If after 3 business days without success of a response, we will have no other alternative but to offer the childcare space available to the next family on the list.<br/>

              </p>
        
              <h3 className="font-bold text-lg mb-2"><br></br>Registration Package and Orientation Forms</h3>
              <p className="mt-2">
              Upon enrolment, you fill out the registration package which includes: 
              a parent contract agreement, child's medical history, a copy of child’s birth certificate, 
              web consent agreement, immunization history, and emergency information. 
              In addition, you will be given a copy of the orientation forms to fill out two weeks prior to your child’s start date.
              </p>
            </div>

            <div style={imageContainerStyle}>
              <PhotoWithBackdrop src="/images/kidsattable.jpg" alt="Childcare Offering" size="full" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}